import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../../i18n/translate"
import { Checkbox } from "../../../form/checkbox/checkbox"

const classnames = require("classnames")

class EnumProductFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ssr: true,
    }
  }

  componentDidMount() {
    this.setState({
      ssr: false,
    })
  }

  render() {
    const { productFilter, t } = this.props
    const { ssr } = this.state

    const inputChanged = (checked, val, group) => {
      if (checked) return group.select(val)
      return group.unselect(val)
    }

    return (
      <>
        {productFilter.values
          .sort((a, b) => t(a.key).localeCompare(t(b.key)))
          .map((val, index) => (
            <div
              className={classnames("_fp-filter-group__item", {
                "_fp-filter-group__item--hidden":
                  !ssr && productFilter.isDisabled(val),
              })}
              key={`enum-product-filter-item-${index}`}
            >
              <Checkbox
                translatedLabel={t(val.key)}
                checked={!ssr && productFilter.isSelected(val)}
                onChange={(checked) =>
                  inputChanged(checked, val, productFilter)
                }
              />
            </div>
          ))}
      </>
    )
  }
}

EnumProductFilter.propTypes = {
  productFilter: PropTypes.object.isRequired,
}

export default withTranslation()(EnumProductFilter)
